import { useQuery } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { isNoResponse } from '@/utils/apiErrors';
import { Logger } from '@/utils/logging';

import type { PaymentSession, UsePaymentSessionQueryParams } from './types';

async function getPaymentSession(cartId: string): Promise<PaymentSession> {
  try {
    const response = await apiClient.get<PaymentSession>(
      `/v1/payment/session/${cartId}`,
    );
    return response.data;
  } catch (error) {
    const log = isNoResponse(error) ? Logger.warn : Logger.error;
    log('Error fetching payment session', { error, cartId });
    throw error;
  }
}

export const usePaymentSessionQuery = ({
  cartId,
  enabled = true,
}: UsePaymentSessionQueryParams) => {
  return useQuery({
    queryKey: ['payment', 'session', cartId],
    queryFn: () => {
      if (!cartId) throw new Error('cartId is required');
      return getPaymentSession(cartId);
    },
    enabled: enabled && !!cartId,
    staleTime: 0,
    retry: false,
  });
};
